import { render, staticRenderFns } from "./message-publish.vue?vue&type=template&id=1288b519&scoped=true&"
import script from "./message-publish.vue?vue&type=script&lang=js&"
export * from "./message-publish.vue?vue&type=script&lang=js&"
import style0 from "./message-publish.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./message-publish.vue?vue&type=style&index=1&id=1288b519&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288b519",
  null
  
)

export default component.exports